import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatSelectChange } from '@angular/material/select';
import { isNullOrUndefined } from 'util';

@Component({
  selector: 'app-belongs-diploma',
  templateUrl: './belongs-diploma.component.html',
  styleUrls: ['./belongs-diploma.component.scss']
})
export class BelongsDiplomaComponent implements OnInit {

  @Input() labelSelect: string;
  @Input() placeHolderInput: string;
  @Input('list') dataList: {id: number; element: string}[];
  @Input() textButtonSave: string;

  @Output() newElement = new EventEmitter<string>();
  @Output() idElementSelected = new EventEmitter<number>();

  listControl = new FormControl('');
  textControl = new FormControl('');


  constructor() { }

  ngOnInit() {
  }

  elementSelected(dataSelect: MatSelectChange): void {
    const value = dataSelect.value;
    if (!isNullOrUndefined(value)) {
      this.idElementSelected.emit(value as number);
    }
  }

  public save(): void {
    const value = this.textControl.value;
    if (value) {
      this.newElement.emit(( value as string).trim().toUpperCase() );
      this.textControl.reset();
    }
  }
 
  public cancel(): void {
    this.listControl.reset();
    this.textControl.reset();
  }

}
